import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getUsers = ({
  currentPage,
  pageSize,
  searchKey,
  role,
  status,
  params = {}
}: {
  currentPage: number,
  pageSize: number,
  searchKey?: boolean,
  role?: string,
  status?: string,
  params: Record<string, string | number | boolean>
}) => {

  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    search_key: searchKey,
    role,
    status,
    ...params
  };

  return axiosPrivate.get(`/dashboard/v1/staff_management`, { params: queryParams });
};